import { JudgeType, Variable } from "@/types/conditionJudgeNodeType";

const VARIABLE_TOKEN_REGEX = /\$\{([1235])-([^}]*)\}/g;
const ALLOWED_VARIABLE_TYPES = new Set<JudgeType>([
  JudgeType.INFO,
  JudgeType.SYSTEM,
  JudgeType.CUSTOM,
  JudgeType.INPUT,
]);

const isAllowedVariableType = (
  type: Variable["type"],
): type is JudgeType => {
  return typeof type === "number" && ALLOWED_VARIABLE_TYPES.has(type);
};

const flattenValidVariableTokens = (variables: Variable[]) => {
  const validTokens = new Set<string>();

  variables.forEach((group) => {
    if (!group.children?.length) {
      return;
    }

    group.children.forEach((child) => {
      if (!isAllowedVariableType(child.type)) {
        return;
      }

      validTokens.add(String(child.value));
    });
  });

  return validTokens;
};

export const sanitizeEndReplyVariableContent = (
  content: string,
  variables: Variable[],
) => {
  if (!content) {
    return {
      cleanedContent: "",
      hasRemovedInvalidRefs: false,
      hasIncompleteVariables: false,
    };
  }

  const validTokens = flattenValidVariableTokens(variables);
  let hasRemovedInvalidRefs = false;
  let hasIncompleteVariables = false;

  const cleanedContent = content.replace(
    VARIABLE_TOKEN_REGEX,
    (match, _type, variableId) => {
      if (!variableId) {
        hasIncompleteVariables = true;
        return match;
      }

      if (validTokens.has(match)) {
        return match;
      }

      hasRemovedInvalidRefs = true;
      return "";
    },
  );

  return {
    cleanedContent,
    hasRemovedInvalidRefs,
    hasIncompleteVariables,
  };
};

export const hasIncompleteEndReplyVariables = (content: string) => {
  if (!content) {
    return false;
  }

  return /\$\{[1235]-\}/.test(content);
};
